import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppComponent } from "./app.component";
import { TitleBarComponent } from "./components/title-bar/title-bar.component";
import { TitleContextMenuComponent } from "./components/title-bar/title-context-menu/title-context-menu.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { SplashComponent } from "./components/title-bar/splash/splash.component";
import { CommonModule } from "@angular/common";
import {SdkRunComponent} from "./components/sdk-run/sdk-run.component";
import {HttpClientModule} from "@angular/common/http";
import {Route, RouterModule} from "@angular/router";
import { MenuOptionsComponent } from "./components/title-bar/menu-options/menu-options.component";
import { IndexComponent } from "./components/index/index.component";
import {ProgressDialogComponent} from "./components/dialogs/progress-dialog/progress-dialog.component";
import {TransactionDialogComponent} from "./components/dialogs/transaction-dialog/transaction-dialog.component";
import {UserInputComponent} from "./components/dialogs/user-input/user-input.component";
import {MatButtonModule} from "@angular/material/button";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatRadioModule} from "@angular/material/radio";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatDividerModule} from "@angular/material/divider";
import {CameraInputComponent} from "./components/dialogs/camera-input/camera-input.component";
import {MatSelectModule} from "@angular/material/select";
import {MatOptionModule} from "@angular/material/core";
import {MatTabsModule} from "@angular/material/tabs";
import {MatAutocompleteModule} from "@angular/material/autocomplete";


const routes: Route[] = [
  {
    path: "",
    redirectTo: "app",
    pathMatch: "full"
  },
  {
    path: "app",
    component: IndexComponent,
    pathMatch: "full"
  }
];

// @ts-ignore
@NgModule({
  declarations: [
    AppComponent,
    TitleBarComponent,
    MenuOptionsComponent,
    TitleContextMenuComponent,
    SplashComponent,
    SdkRunComponent,
    IndexComponent,
    ProgressDialogComponent,
    TransactionDialogComponent,
    UserInputComponent,
    CameraInputComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(routes, {enableTracing: false, relativeLinkResolution: 'legacy'}),
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatRadioModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatDividerModule,
    MatSelectModule,
    MatOptionModule,
    HttpClientModule,
    MatTabsModule,
    MatAutocompleteModule
  ],
  providers: [],
  entryComponents: [
    ProgressDialogComponent,
    UserInputComponent],
  bootstrap: [AppComponent]
})
export class AppModule {
   constructor() {

   }
}
